import React, { useEffect, useState } from 'react'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import Loader from '../../../../components/elements/Loader';
import { useDispatch, useSelector } from 'react-redux';
import EmptyState from '../../../../components/elements/EmptyState';
import { clearCreatedDownloadable, clearDeletedDownloadable, clearUpdatedDownloadable, deleteDownloadable, fetchDownloadables } from '../../../../store/actions/downloadablesActions';
import Pagination from '../../../../components/elements/Pagination';
import ModalDialog from '../../../../components/layouts/ModalDialog';
import { SET_SUCCESS } from '../../../../store/types';
import DownloadableCard from '../../../../components/partials/downloadables/DownloadableCard';
import EditDownloadable from '../../../../components/partials/downloadables/EditDownloadable';
import NewDownloadable from '../../../../components/partials/downloadables/NewDownloadable';

const Downloadables = () => {
    const dispatch = useDispatch()
    const downloadablesSelector = useSelector(state => state.downloadables)
    const [creatingDownloadable, setCreatingDownloadable] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);

    useEffect(() => {
        dispatch(fetchDownloadables('', page, perPage))

        if(downloadablesSelector.createdDownloadable !== null){
            dispatch(clearCreatedDownloadable())
            dispatch({
                type: SET_SUCCESS,
                payload: 'New downloadable created!'
            })
            setCreatingDownloadable(false)
        }

        if(downloadablesSelector.updatedDownloadable !== null){
            dispatch(clearUpdatedDownloadable())
            dispatch({
                type: SET_SUCCESS,
                payload: 'Downloadable updated successfully!'
            })
            closeDownloadable()
        }

        if(downloadablesSelector.deletedDownloadable !== null){
            dispatch(clearDeletedDownloadable())
            dispatch({
                type: SET_SUCCESS,
                payload: 'Downloadable deleted successfully!'
            })
        }

        return () => {
            
        };

    }, [dispatch, page, perPage, downloadablesSelector.createdDownloadable, downloadablesSelector.updatedDownloadable, downloadablesSelector.deletedDownloadable]);

    const [activeDownloadable, setActiveDownloadable] = useState(null);
    const [editingDownloadable, setEditingDownloadable] = useState(false);
    const openDownloadable = (downloadable) => {
        setActiveDownloadable(downloadable)
        setTimeout(() => {
            setEditingDownloadable(true)
        }, 200);
    }

    const closeDownloadable = () => {
        setEditingDownloadable(false)
        setTimeout(() => {
            setActiveDownloadable(null)
        }, 200);
    }
    
    const doDelete = (id) => {
        if(window.confirm('This downloadable will be deleted and removed from alll platforms. Please confirm to proceed.')){
            dispatch(deleteDownloadable(id))
        }
    }

    return (
        <>
            <AdministrationLayout>
                <div className='w-full'>
                    <div className='w-full flex justify-between'>
                        <div className='w-9/12'>
                            <h3 className='text-lg font-medium'>Vaatia College Downloadables</h3>
                            <p className='text-sm'>Downloadables are documents or other general media made available to users of this platform to download at any time. Once created, they can be pulled and displayed on the website, parents portal or have their links shared directly.</p>
                        </div>
                        
                        <div>
                            <button onClick={()=>{setCreatingDownloadable(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                            <PlusIcon className='w-5 h-5' /> Create Downloadable
                            </button>
                        </div>
                    </div>

                    {downloadablesSelector.loadingDownloadables
                    ? 
                        <Loader /> 
                    :
                        downloadablesSelector?.downloadables?.downloadables?.length > 0 ? <>
                            <div className='w-full grid grid-cols-4 gap-[10px] mt-[50px]'>
                                {downloadablesSelector?.downloadables?.downloadables?.map((downloadable, downloadableIndex) => (
                                    <div key={downloadableIndex} className='w-full'>
                                        <DownloadableCard 
                                            downloadable={downloadable} 
                                            openDownloadable={()=>{openDownloadable(downloadable)}} 
                                            deleteDownloadable={()=>{doDelete(downloadable._id)}} 
                                        />
                                    </div>
                                ))}
                            </div>

                            <Pagination 
                                pagination={{
                                    perPage, 
                                    page,
                                    totalItems: downloadablesSelector?.downloadables?.total,
                                }} 
                                changePage={setPage} 
                                updatePerPage={setPerPage}
                            />
                        </>
                        : 
                        <div className='mt-12'>
                            <EmptyState
                                emptyStateText={`No downloadables created yet. Please create some by clicking the "Create Downloadable" button above`}
                            />
                        </div>
                    }
                </div>
            </AdministrationLayout>

            <ModalDialog
                shown={creatingDownloadable} 
                closeFunction={()=>{setCreatingDownloadable(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Create a new Downloadable'
                maxWidthClass='max-w-4xl'
                hideActions={true}
            >
                <NewDownloadable closeFunction={()=>{setCreatingDownloadable(false)}} />
            </ModalDialog>

            {activeDownloadable && <ModalDialog
                shown={editingDownloadable} 
                closeFunction={()=>{setEditingDownloadable(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Update Downloadable'
                maxWidthClass='max-w-4xl'
                hideActions={true}
            >
                <EditDownloadable
                    downloadable={activeDownloadable} 
                    closeFunction={()=>{setEditingDownloadable(false)}}
                />

            </ModalDialog>}
        </>
    )
}

export default Downloadables